import React from "react";

function LeftSection({ imageURL, productName, productDescription, tryDemo, learnMore, googleplay, appstore }) {
    return (
        <div className="container mt-5">
            <div className="row mt-5">
                <div className="col-6 p-5">
                    <img src={imageURL} />
                </div>
                <div className="col-6 p-5 mt-5">
                    <h1>{productName}</h1>
                    <p className="">{productDescription}</p>
                    <div className="m-3">
                        <b>
                        <a href="{tryDemo}" className="" style={{marginRight:'10%' ,textDecoration:"none"}}>Try Demo<i class="fa fa-long-arrow-right" aria-hidden="true"></i></a>
                        <a href="{learnMore}" style={{marginLeft:"50%", textDecoration:"none"}} className="p-3 m-3">Learn More<i class="fa fa-long-arrow-right" aria-hidden="true"></i></a>
                        </b>
                    </div>
                    <div className="m-3">
                        <a href="{googleplay}"><img src="media/googlePlayBadge.svg" /></a>
                        <a href="{appStore}" style={{marginLeft:"5%"}}><img src="media/appstoreBadge.svg" /></a>
                    </div>


                </div>

            </div>
        </div >
    );
}

export default LeftSection;